import { render, staticRenderFns } from "./AIReworkButton.vue?vue&type=template&id=89f5120a&"
import script from "./AIReworkButton.vue?vue&type=script&lang=ts&"
export * from "./AIReworkButton.vue?vue&type=script&lang=ts&"
import style0 from "./AIReworkButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports